import { useActiveCoachReviewsContext } from "./useActiveCoachReviewsContext";
import { useQuery } from "@tanstack/react-query";

export const useGetReviewsSummary = ({ enabled }: { enabled: boolean }) => {
	const { gameId, promises } = useActiveCoachReviewsContext();

	if (!promises) {
		throw new Error("Coach review promises are not available");
	}

	return useQuery({
		queryKey: ["coachReviewsSummary", gameId], // TODO: Move into key factory
		queryFn: () => promises.getCoachReviewsSummary({ id: gameId }),
		enabled,
	});
};
